"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBrandAdminReset = exports.makeBrandAdmin = exports.brandAdminSuccess = exports.brandAdminSearch = exports.brandAdminFindTemplate = exports.brandAdminFindReset = exports.brandAdminError = void 0;
var _brandAdmin = require("./brandAdmin.constant");
// common success
var brandAdminSuccess = function brandAdminSuccess(actionType, data) {
  return {
    type: _brandAdmin.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.brandAdminSuccess = brandAdminSuccess;
var brandAdminError = function brandAdminError(actionType, error) {
  return {
    type: _brandAdmin.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Brand admin user
 * @param payload
 * @returns api response
 * @description this function used to make brand admin user.
 */
exports.brandAdminError = brandAdminError;
var makeBrandAdmin = function makeBrandAdmin(payload) {
  return {
    type: _brandAdmin.actionTypes.MAKE_BRAND_ADMIN,
    payload: payload
  };
};

/**
 * Search brand admin
 * @param payload
 * @returns api response
 * @description this function used to search brand admin by templates Id.
 */
exports.makeBrandAdmin = makeBrandAdmin;
var brandAdminSearch = function brandAdminSearch(data) {
  return {
    type: _brandAdmin.actionTypes.SEARCH,
    payload: data
  };
};

/**
 * Find brand admin
 * @param payload
 * @returns api response
 * @description this function used to find brand admin by templates Id.
 */
exports.brandAdminSearch = brandAdminSearch;
var brandAdminFindTemplate = function brandAdminFindTemplate(data) {
  return {
    type: _brandAdmin.actionTypes.FIND,
    payload: data
  };
};

/**
 * Find brand admin
 * @param payload
 * @returns api response
 * @description this function used to find brand admin by templates Id.
 */
exports.brandAdminFindTemplate = brandAdminFindTemplate;
var brandAdminFindReset = function brandAdminFindReset() {
  return {
    type: _brandAdmin.actionTypes.FINDRESET
  };
};

/**
 * brand admin user
 * @param payload
 * @returns api response
 * @description this function used to reset brand admin user.
 */
exports.brandAdminFindReset = brandAdminFindReset;
var makeBrandAdminReset = function makeBrandAdminReset(payload) {
  return {
    type: _brandAdmin.actionTypes.MAKE_BRAND_ADMIN_RESET,
    payload: payload
  };
};
exports.makeBrandAdminReset = makeBrandAdminReset;